<script setup lang="ts">
import type { MapPosition } from "@/components/map/types";
import SaveButton from "@/components/SaveButton.vue";
import type { House } from "@/houses/types";
import { Xmark } from "@iconoir/vue";
import type { MutationStatus } from "@tanstack/vue-query";
import { computed, ref, toRaw } from "vue";
import AreaEditor from "./AreaEditor.vue";
import { isPolygon } from "./mapUtils";
import type { Area } from "./types";

const props = defineProps<{
  area: Area;
  updatingStatus: MutationStatus;
  houses?: Array<House>;
  defaultMapPosition: MapPosition;
}>();

const area = ref(structuredClone(toRaw(props.area)));

const emit = defineEmits<{
  update: [area: Area];
}>();

const submitAttempted = ref(false);

const isIncompleteArea = computed(
  () => submitAttempted.value && !isPolygon(area.value.coordinates),
);

const submit = () => {
  submitAttempted.value = true;
  if (!isPolygon(area.value.coordinates)) return;

  emit("update", area.value);
};
</script>

<template>
  <form class="column box" @submit.prevent="submit">
    <div>
      <label for="name">Name</label>
      <input id="name" v-model="area.name" type="text" name="name" required />
    </div>
    <AreaEditor
      v-model="area.coordinates"
      :houses="houses ?? []"
      :default-map-position="defaultMapPosition"
    />
    <section v-if="isIncompleteArea" class="error" role="alert">
      Bitte zeichne erst das Gebiet auf der Karte ein, bevor du speicherst.
    </section>
    <div class="row row-end">
      <RouterLink
        :to="{ name: 'areas' }"
        class="button button--secondary"
        role="button"
        ><Xmark /> Zurück zur Übersicht</RouterLink
      >
      <SaveButton :saving-status="updatingStatus">Speichern</SaveButton>
    </div>
  </form>
</template>
